<template>
  <div>
    <generic-table
      ref="datatable_owner"
      :title="$t('user purchases')"
      :columns="columns"
      :column_search="true"
      resource_url="/purchase/user/datatables"
      @selected="$emit('selected', $event)"
      v-show="sales_component == 'user'"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/purchase/pop' })"
        >
          <span class="icon"><i class="fa fa-money"></i></span>
          <span>{{ $t("point of purchase") }}</span>
        </button>
        <button
          class="button is-secondary is-rounded"
          @click="sales_component = 'all'"
        >
          <span class="icon"><i class="fa fa-list"></i></span>
          <span>{{ $t("all purchases") }}</span>
        </button>
      </template>
    </generic-table>
    <generic-table
      ref="datatable_all"
      :title="$t('all purchases')"
      :columns="columns"
      :column_search="true"
      resource_url="/purchase/datatables"
      @selected="$emit('selected', $event)"
      v-show="sales_component == 'all'"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/purchase/pop' })"
        >
          <span class="icon"><i class="fa fa-money"></i></span>
          <span>{{ $t("point of purchase") }}</span>
        </button>
        <button
          class="button is-secondary is-rounded"
          @click="sales_component = 'user'"
        >
          <span class="icon"><i class="fa fa-list"></i></span>
          <span>{{ $t("user purchases") }}</span>
        </button>
      </template>
    </generic-table>
  </div>
  <!-- <pre>{{ $props.module_settings }}</pre> -->
  <view-purchase-modal ref="view_purchase_modal" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  // format_time,
  format_date_time,
  format_currency,
  // format_date,
} from "@/utils";
import ViewPurchaseModal from "./view_purchase_modal/Index.vue";

export default {
  name: "SalesDatatable",
  components: { GenericTable, ViewPurchaseModal },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  computed: {},
  data() {
    let v = this;
    return {
      sales_component: "", // "user" or "all
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          name: "create_date",
          width: "17%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date_time(row.create_date) || "";
          },
        },
        // {
        //   title: v.$t("payment"),
        //   searchable: false,
        //   name: "payment",
        //   width: "25%",
        //   data: (row) => {
        //     let rows = row.payment.reduce((prev, curr) => {
        //       return (
        //         prev +
        //         `<span class="mr-3">${format_currency(curr.amount)} ${
        //           curr.name
        //         }</span>`
        //       );
        //     }, "");
        //     let list = `<div>${rows}</div>`;
        //     return list;
        //     // return `<pre>${JSON.stringify(row.payment, null, 2)}</pre>`;
        //     // return row.payment || "";
        //   },
        // },
        {
          title: v.$t("products"),
          searchable: false,
          name: "payment",
          width: "45%",
          data: (row) => {
            // let rows = row.sale_products.reduce((prev, curr) => {
            //   return (
            //     prev +
            //     `<li>${
            //       curr.product.name
            //     } <span class="is-pulled-right">${format_currency(
            //       curr.sale_price
            //     )}</span> </li>`
            //   );
            // }, "");
            // let list = `<ul>${rows}</ul>`;
            let rows = row.purchase_products.reduce((prev, curr) => {
              return (
                prev +
                `<div class="control">
                  <div class="tags has-addons">
                    <span class="tag is-dark">${format_currency(
                      curr.purchase_price * curr.quantity
                    )}</span>
                    <span class="tag ">${curr.quantity} x ${
                  curr.product.name
                } (${format_currency(curr.purchase_price)})</span>
                  </div>
                </div>`
              );
            }, "");
            return `<div class="field is-grouped is-grouped-multiline">${rows}</div>`;
            // return `<pre>${JSON.stringify(row.payment, null, 2)}</pre>`;
            // return row.payment || "";
          },
        },
        {
          title: v.$t("total"),
          name: "total",
          width: "10%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.total) || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.view_purchase_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete sale?"),
                    v,
                    () => {
                      del("/purchase", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // create() {
    //   let v = this;
    //   v.$refs.product_modal.show_modal();
    // },
    refresh() {
      let v = this;
      if (v.sales_component == "user" && v.$refs.datatable_owner)
        v.$refs.datatable_owner.refresh();
      if (v.sales_component == "all" && v.$refs.datatable_all)
        v.$refs.datatable_all.refresh();
    },
  },
  mounted() {
    // console.log(this.$props.module_settings);
    // this.refresh();
  },
  watch: {
    module_settings() {
      if (this.module_settings.default_purchase_view)
        this.sales_component = this.module_settings.default_purchase_view;
    },
  },
};
</script>

<style></style>
